export default "__VITE_ASSET__BrYWdWlG__"